import { Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import { getPracticeUsersRequest } from "../../../modules/admin-modules/asquera-practice/Actions";
import { getUserSubscriptions } from "./helpers";

const PracticeUsersTable = ({ onUserClick, searchTerm }) => {
  const dispatch = useDispatch();
  const users = useSelector((state) => state.asqueraPractice.users);
  const isLoading = useSelector((state) => state.asqueraPractice.isLoading);
  const lastPage = useSelector((state) => state.asqueraPractice.lastPage) || 1;
  const [pageNumber, setPageNumber] = useState(0);
  const [size, setPerPage] = useState(10);
  const [offset, setPage] = useState(0);

  useEffect(() => {
    setPageNumber(0);
  }, [searchTerm]);

  useEffect(() => {
    const timeId = setTimeout(() => {
      dispatch(getPracticeUsersRequest(pageNumber + 1, searchTerm || ""));
    }, 200);

    return () => {
      clearTimeout(timeId);
    };
  }, [dispatch, pageNumber, searchTerm]);

  const list = Array.isArray(users) ? users : [];

  const viewData = (data) => {
    onUserClick(data);
  };

  const Data = list.map((data, index) => {
    const subscriptions = getUserSubscriptions(data);
    return {
      ...data,
      index: `#${pageNumber * size + index + 1}`,
      id: data?.id,
      student_name: (
        <Text
          cursor="pointer"
          color="main_1"
          fontWeight="600"
          textDecoration="underline"
          onClick={(e) => {
            e.stopPropagation();
            onUserClick(data);
          }}
        >
          {data?.name || "-"}
        </Text>
      ),
      phone: data?.phone || "-",
      user_name: data?.user_name || "-",
      subscriptions_count: subscriptions.length,
    };
  });

  const columns = [
    {
      Header: "رقم",
      accessor: "index",
    },
    {
      Header: "الاسم",
      accessor: "student_name",
    },
    {
      Header: "اسم المستخدم",
      accessor: "user_name",
    },
    {
      Header: "رقم الهاتف",
      accessor: "phone",
    },
    {
      Header: "عدد الاشتراكات",
      accessor: "subscriptions_count",
    },
  ];

  return (
    <CTable
      selectedData={viewData}
      Columns={columns}
      Data={Data}
      path={"openModel"}
      Title=""
      subTitle=""
      btnTitle=""
      placeHolder=""
      noSearchBar={true}
      noFilter={true}
      footerBtnTitle
      filterList
      addButton
      addButtonTitle=""
      setPage={setPage}
      setPerPage={setPerPage}
      currentpage={pageNumber}
      setPageNumber={setPageNumber}
      noSecondSearchBar={true}
      isLoading={isLoading}
      perPage={size}
      totalPage={lastPage}
    />
  );
};

export default PracticeUsersTable;
